import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import WriteXmlForm from '../forms/write-xml-form';
import { xmlWriteValidationSchema } from '../schema/xml.js';

export default function WriteXmlNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Write XML Node Details',
        altText: 'Write XML Node',
        defaultLabel: 'Write XML Node',
      }}
    >
      <CommonNode FormComponent={WriteXmlForm} schemaResolver={xmlWriteValidationSchema} />
    </NodeProvider>
  );
}
